<template>
  <div class="formBuilder-wrapper-preview">
    <div id="formBuilderDiv" class="formBuilder-inner-preview overflow-auto">
      <div class="border-bottom-gray">
        <div class="form-fields py-5">
          <div class="form-grp px-5">
            <div class="font-weight-600 font-size-15">Checklists</div>
          </div>
        </div>
      </div>
      <div class="builderFormWrapperView">
        <Container
          group-name="form-builder-grpup"
          class="form-drag-container builderFormWrapper"
        >
          <div v-for="(element, index) in data" :key="`checklist-${index}`">
            <div class="form-fields py-5" v-if="element">
              <div class="form-grp px-5">
                <label class="fw-500" v-if="element && !element.hidelabel">{{
                  element.label
                }}</label>
                <template>
                  <v-row>
                    <v-col
                      :md="element.column"
                      v-for="(choice, coiceIndex) in element.choices"
                      :key="`choice-${coiceIndex}`"
                    >
                      <v-checkbox
                        hide-details
                        v-model="choice.check_status"
                        :label="choice.label"
                        class="mt-0"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </template>
                <p
                  class="text-muted mt-2 mb-0"
                  v-if="element && element.instructions != null"
                >
                  {{ element.instructions }}
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  </div>
</template>
<script>
import { Container } from "vue-smooth-dnd";
import FieldList from "@/view/pages/serviceFormTemplate/FieldList.json";
import { cloneDeep } from "lodash";
export default {
  name: "Form_builder",
  props: {
    data: {
      type: Array,
      default: new Array(),
    },
  },
  watch: {
    data: {
      handler() {
        this.initData();
      },
      deep: true,
      immediate: false,
    },
  },
  data() {
    return {
      checklist_data: [],
      title: null,
      datePicker: false,
      field_list: FieldList,
      db_preview_components: [],
      hh_List: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mm_List: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      type_List: ["AM", "PM"],
    };
  },
  methods: {
    initData() {
      const _this = this;
      _this.checklist_data = cloneDeep(_this.data);
    },
  },
  mounted() {
    this.initData();
  },
  components: {
    Container,
  },
};
</script>
<style scoped>
.sticky-title {
  padding-top: 6px;
  padding-bottom: 7px;
  position: sticky;
  top: 0;
  background: #eef0f8;
  z-index: 6;
}

.page-break {
  position: relative;
  width: 100%;
  height: 50px;
  /* Adjust height as needed */
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-break::before,
.page-break::after {
  content: "";
  position: absolute;
  top: 24px;
  bottom: 0;
  width: 30%;
  height: 2px;
  background-color: black;
}

.page-break::before {
  left: 10%;
}

.page-break::after {
  right: 10%;
}

.page-break span {
  background: white;
  padding: 0 10px;
  font-size: 18px;
  font-weight: bold;
}
</style>
